import { useTranslation } from 'react-i18next'
import type { DaoUrlDto } from '@/infra/api/generated/model'
import { twMerge } from 'tailwind-merge'

const labelClassName = 'flex items-center gap-4 p-4 border rounded-md transition-colors'
const inputClassName = 'w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer'

type DaoGridHeightOptionProps = {
  daoUrlDto: DaoUrlDto
  isSelected: boolean
  onSelect: (daoUrl: string) => void
}

const DaoGridHeightOption = ({ daoUrlDto, isSelected, onSelect }: DaoGridHeightOptionProps) => {
  const { t } = useTranslation('common')
  const { daoUrl, gridHeight } = daoUrlDto
  const isAvailable = Boolean(daoUrl)

  return (
    <label
      data-testid={`dao-grid-height-label-${gridHeight}`}
      className={twMerge(
        labelClassName,
        !isAvailable && 'opacity-50 cursor-not-allowed',
        isAvailable && 'cursor-pointer hover:bg-gray-50',
        isSelected && 'border-blue-600',
        !isSelected && 'border-gray-300'
      )}
    >
      <input
        type="radio"
        name="daoGridHeight"
        value={daoUrl || ''}
        disabled={!isAvailable}
        checked={isSelected}
        onChange={() => daoUrl && onSelect(daoUrl)}
        className={inputClassName}
      />
      <span className="text-lg font-medium text-gray-900">
        {t('pages.questions.dao-grid-height-modal.option')} {gridHeight}
      </span>
    </label>
  )
}

export default DaoGridHeightOption
